import { render, staticRenderFns } from "./AnnounDialog.vue?vue&type=template&id=e7d8a032&scoped=true&"
import script from "./AnnounDialog.vue?vue&type=script&lang=js&"
export * from "./AnnounDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d8a032",
  null
  
)

export default component.exports